namespace GeniuzPOS.RefundReasonReport {
    export class ReportRefundReasonByItemColumns {
        static columnsKey = 'RefundReasonReport.ReportRefundReasonByItem';
    }
}
